
export function LazyLoad(){
  // Get all the lazy-loadable elements
  const lazyLoadElements = document.querySelectorAll('[data-src]');

  // Function to check if an element is in the viewport
  const isElementInViewport = element => {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    return (
      rect.top <= windowHeight &&
      rect.bottom >= 0 &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right >= 0
    );
  };

  // Function to lazy load the elements
  const lazyLoadElementsOnScroll = () => {
    lazyLoadElements.forEach(element => {
      if (isElementInViewport(element) && element.getAttribute('src') === '') {
        const src = element.getAttribute('data-src');
        element.setAttribute('src', src);
      }
    });
  };

  // Attach the lazyLoadElementsOnScroll function to the scroll event
  window.addEventListener('scroll', lazyLoadElementsOnScroll);

}



// WEBPACK FOOTER //
// ./src/ktu/js/components/LazyLoad.js